import React, { ReactNode } from 'react';
import './AuthLayout.scss';
import LeftBanner from './LeftBanner/LeftBanner';
import LangSwitcher from '../../LangSwitcher/LangSwitcher';

interface IProps {
  children: ReactNode;
}

function AuthLayout(props: IProps) {
  return (
    <div className="lg:flex min-h-screen ">
      <LeftBanner />
      <div className="flex flex-col max-lg:w-full justify-center flex-grow p-4 max-lg:p-0">
        {/*<div className="flex justify-end px-10 pb-8">*/}
        {/*  <LangSwitcher />*/}
        {/*</div>*/}
        <div className="flex  justify-center px-5 max-lg:px-0 pb-8">
          {props.children}
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
